import { extendObservable } from "mobx";
import sffjs from "sffjs";

export default class UnitBinding {
  constructor() {
    extendObservable(this, {
      ConversionFactorToUI: 1,
      UnitConfigBinding: "",
      FormatString: "",
      UnitId: null,
      UnitShortDescription: "",
      DivUnit: null
    });
  }

  get decimalChar() {
    return sffjs.LC._r;
  }

  updateFromJson(json) {
    this.ConversionFactorToUI = parseFloat(json.ConversionFactorToUI);
    this.UnitConfigBinding = json.UnitConfigBinding;
    this.FormatString = json.FormatString;
    this.UnitId = json.UnitId;
    this.UnitShortDescription = json.UnitShortDescription;
    if (json.DivUnit) this.DivUnit = new UnitBinding(json.DivUnit);
    else this.DivUnit = null;
  }

  toDisplayValue(value) {
    let convertedValue = null;
    if (value !== null) convertedValue = value * this.ConversionFactorToUI;
    return convertedValue;
  }

  fromDisplayValue(value) {
    let convertedValue = null;
    if (value !== null && this.ConversionFactorToUI !== 0)
      convertedValue = value / this.ConversionFactorToUI;
    return convertedValue;
  }

  formatDisplayValue(value) {
    return this.formatValue(this.toDisplayValue(value));
  }

  parseDisplayValue(value) {
    return this.fromDisplayValue(this.parseValue(value));
  }

  formatValue(value) {
    const formatString =
      this.FormatString && this.FormatString.length > 0
        ? "{0:" + this.FormatString + "}"
        : "{0}";
    return sffjs(formatString, value);
  }

  fullFormattedValue(value) {
    return sffjs("{0:G}", value);
  }

  fullFormattedDisplayValue(value) {
    const displayValue = this.toDisplayValue(value);
    return this.fullFormattedValue(displayValue);
  }

  parseValue(value) {
    let parsedValue = value;
    if (value === null || value === "") {
      parsedValue = null;
    } else {
      // we halen onze comma en thousands separator op uit onze huidige culture
      const commaSep = sffjs.LC._r;
      const thousandsSep = sffjs.LC._t;
      // thousands separator weghalen
      if (thousandsSep && thousandsSep.length > 0)
        value = value.replace(new RegExp(`\\${thousandsSep}`, "g"), "");
      // comma separator vervangen met . zodat parseFloat correct kan werken
      if (commaSep && commaSep.length > 0 && commaSep !== ".")
        value = value.replace(new RegExp(`\\${commaSep}`, "g"), ".");
      parsedValue = parseFloat(value);
    }
    return parsedValue;
  }
}



// WEBPACK FOOTER //
// ./src/Core/UnitBinding.js